import { combineReducers } from "redux";
import auth from "./Auth/reducers";
import excopusat from "./ExcoPusat/reducers";
import global from "./Global/reducers";
import excoprovinsi from "./ExcoProvinsi/reducers";
import excokabkot from "./ExcoKabKot/reducers";
import excokecamatan from "./ExcoKecamatan/reducers";
import excokelurahan from "./ExcoKelurahan/reducers";
import users from "./UserManagement/reducers";
import excodetail from "./ExcoDetailPusat/reducers";
import anggota from "./Anggota/reducers";
import pengurus from "./Pengurus/reducers";
import dokumen from "./Dokumen/reducers";
import daftarAnggota from "./DaftarAnggota/reducers";
import download from "./Download/reducers";
import overview from "./Overview/reducers";

const appReducer = combineReducers({
  auth,
  excopusat,
  global,
  excoprovinsi,
  excokabkot,
  excokecamatan,
  users,
  excodetail,
  anggota,
  pengurus,
  dokumen,
  daftarAnggota,
  download,
  overview,
  excokelurahan
});

const createRootReducer = () => (state, action) => {
  // Reset all state on logout
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default createRootReducer;
